import type { SupportLevel } from '../../content/types';

type StatusDotProps = {
  level: SupportLevel;
  className?: string;
};

const ARIA_LABELS: Record<SupportLevel, string> = {
  yes: 'Fully supported',
  partial: 'Partial or limited',
  no: 'Not supported',
};

// Status indicator colors:
//   yes     → bright green (#98ff01) — full support
//   partial → amber/gold (#ffb401) — partial support
//   no      → empty ring (white 30% opacity border) — no support
// Exception to the zero-radius rule: these are visual signal glyphs, not UI
// chrome, so rounded-full is deliberate and documented.
const LEVEL_CLASSES: Record<SupportLevel, string> = {
  yes: 'bg-[#98ff01]',
  partial: 'bg-[#ffb401]',
  no: 'border border-[rgb(255_255_255_/_30%)] bg-transparent',
};

export function StatusDot({ level, className }: StatusDotProps) {
  return (
    <span
      role="img"
      aria-label={ARIA_LABELS[level]}
      className={
        `inline-block h-3 w-3 rounded-full ${LEVEL_CLASSES[level]}` +
        (className ? ` ${className}` : '')
      }
    />
  );
}
